<template>
  <div class="father">
    
    <wtycanvas></wtycanvas>
  </div>
</template>
<script>
import wtycanvas from "@/components/wty-canvas.vue";
export default {
  name:"drawtemplate",
  components:{wtycanvas}
};
</script>
<style lang="less" scoped>

</style>
